import styled from '@emotion/styled';

export const Wrapper = styled.div``;

export const DetailsContent = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 3.875rem;
`;
